import { createContext, useContext } from 'react'
import { UseFormRegisterReturn } from 'react-hook-form'

export const RadioGroupContext = createContext<UseFormRegisterReturn | null>(null)
export const useRadioGroupContext = () => {
  const context = useContext(RadioGroupContext)
  if (!context) throw new Error('RadioGroupContext must be used within a RadioGroup!')
  return context
}
